import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from '../../../@crema/utility/AppContext';
import { ThemeMode } from '../../constants/AppEnums';
import Hidden from '@material-ui/core/Hidden';
import AppContextPropsType from '../../../types/AppContextPropsType';

const GooglePlayLogos = () => {
    const { themeMode } = useContext<AppContextPropsType>(AppContext);
    const useStyles = makeStyles(() => ({
        logoRoot: {
            display: 'flex',
            flexDirection: 'row',
            cursor: 'pointer',
            alignItems: 'center',
        },
        logo: {
            height: 37,
            marginRight: 10,
        },
        qrCode: {
            height: 80,
            marginRight: 10,
        },
    }));
    const classes = useStyles();
    return (
        <>
            <Box className={classes.logoRoot}>
                <Hidden smUp>
                    <img
                        className={classes.qrCode}
                        src={
                            themeMode === ThemeMode.DARK
                                ? '/assets/images/appstoreimages/GooglePlayQRCode.png'
                                : '/assets/images/appstoreimages/GooglePlayQRCode.png'
                        }
                        alt='EdgeAppStoreQRCode'

                    />
                </Hidden>
                <Hidden xsDown>
                    <img
                        className={classes.qrCode}
                        src={
                            themeMode === ThemeMode.DARK
                                ? '/assets/images/appstoreimages/GooglePlayQRCode.png'
                                : '/assets/images/appstoreimages/GooglePlayQRCode.png'
                        }
                        alt='EdgeAppStoreQRCode'
                    />
                </Hidden>
                <Hidden smUp>
                    <img
                        className={classes.logo}
                        src={
                            themeMode === ThemeMode.DARK
                                ? '/assets/images/appstoreimages/GetItOnGooglePlay.png'
                                : '/assets/images/appstoreimages/GetItOnGooglePlay.png'
                        }
                        alt='DownloadEdgeForIos'
                        onClick={() => window.open("https://play.google.com/store/apps/details?id=com.ibcco_op.com.ibcedge", '_blank')}
                    />
                </Hidden>
                <Hidden xsDown>
                    <img
                        className={classes.logo}
                        src={
                            themeMode === ThemeMode.DARK
                                ? '/assets/images/appstoreimages/GetItOnGooglePlay.png'
                                : '/assets/images/appstoreimages/GetItOnGooglePlay.png'
                        }
                        alt='DownloadEdgeForIos'
                        onClick={() => window.open("https://play.google.com/store/apps/details?id=com.ibcco_op.com.ibcedge", '_blank')}
                    />
                </Hidden>
            </Box>
        </>
    );
};

export default GooglePlayLogos;
